// extracted by mini-css-extract-plugin
export default {"h2":"Info_h2__kv3lV","h3":"Info_h3__b7xm7","h4":"Info_h4__7ykk9","h5":"Info_h5__r7B0P","h6":"Info_h6__Vz2G7","p":"Info_p__3O63N"};